<div class="page-layout">
  <ng-content></ng-content>
</div>
